import React from 'react';
import {
	Button,
	TextInput,
	TextArea,
	FormGroup,
	FormLabel,
	RadioButtonGroup,
	RadioButton,
	Checkbox,
	InlineNotification,
	DatePicker,
	DatePickerInput,
	Select,
	SelectItem
} from 'carbon-components-react';
import {t} from 'i18next';
import { Icomoon } from '../Icomoon';
import { PostContent } from '../PostContent';
import {map, isArray, indexOf} from 'lodash';

const FormField = ({field, name, ...other}) => {
	if (!field) {
		return null;
	}
	// Give controllers an opportunity to fully render the fields themselves.  This was helpful for the password reset
	// field where we needed a reference to the ReactPasswordStrength field.
	if (field.field) {
		return field.field;
	}
	switch (field.type) {
		case 'notification':
			return <InlineNotification
				title={field.label}
				subtitle=""
				kind={field.value}
				hideCloseButton
			/>;
		case 'checkbox':
			const checkboxChoices = (field.choices) ? map(field.choices, (choiceName, choiceValue) => {
				let labelText = choiceName;
				if ( labelText.match( /http.*(jpg|png|jpeg|svg|gif)/ ) ) {
					// It's an image url, change the label to be the actual image
					labelText = <img src={labelText} alt={labelText} />
				}
				return <Checkbox
					key={choiceValue}
					value={choiceValue}
					id={'input_' + field.id + '_' + choiceValue}
					labelText={labelText}
					name={name}
					defaultChecked={(isArray(field.value) ? (indexOf(field.value, choiceValue) !== -1) : field.value === choiceValue)}
				/>
			}) : '';
			return <div className="tbk--form-fields__options">
				<FormGroup legendText={field.label}>
					{checkboxChoices}
				</FormGroup>
			</div>;
		case 'textarea':
			return <div className="tbk--form-row">
				<TextArea
					light
					id={name}
					labelText={field.label}
					name={name}
					defaultValue={field.value}
					className="tbk--page-edit-profile__textarea"
					placeholder={field.placeholder}
					required={!!field.required}
				/>
			</div>;
		case 'true_false':
			return <div className="tbk--form-fields__true-false">
				<FormGroup legendText={field.label}>
					<Checkbox
						id={t('toggle-'+name)}
						labelText={field.label}
						name={name}
						defaultChecked={(true===field.value)}
					/>
				</FormGroup>
			</div>;
		case 'select':
			const selectChoices = (field.choices) ? map(field.choices, (choiceName, value) => (
				<SelectItem
					key={t(name+'-'+value)}
					value={choiceName}
					text={choiceName}
				/>
			)) : '';
			return <Select
				className=""
				id={name}
				name={name}
				required={!!field.required}
				light
			>
				{selectChoices}
			</Select>;
		case 'radio':
			const radioChoices = (field.choices) ? map(field.choices, (choiceName, value) => {
				let labelText = choiceName;
				if ( labelText.match( /http.*(jpg|png|jpeg|svg|gif)/ ) ) {
					// It's an image url, change the label to be the actual image
					labelText = <img src={labelText} alt={labelText} />
				}
				return <RadioButton
					key={t(name + '-' + value)}
					value={value}
					id={t(name + '-' + value)}
					labelText={labelText}
				/>
			}) : '';
			return <div className="tbk--form-fields__radio">
				<FormGroup legendText={field.label}>
					<RadioButtonGroup
						name={name}
						defaultSelected={field.value}
						required={!!field.required}
					>{radioChoices}</RadioButtonGroup>
				</FormGroup>
			</div>;
		case 'day_picker':
			// A special case of date picker where we only want the month & day, not the year
			return <DatePicker
				light
				short
				datePickerType="single"
				dateFormat="m/d"
			>
				<DatePickerInput
					labelText={field.label}
					placeholder="MM/DD"
					autoComplete="off"
					pattern="\d{1,2}\/\d{1,2}"
					id={name}
					name={name}
					value={field.value}
					required={!!field.required}
				/>
			</DatePicker>;
		case 'date_picker':
		case 'date':
			return <DatePicker
				light
				datePickerType="single"
				dateFormat="m/d/Y"
			>
				<DatePickerInput
					labelText={field.label}
					placeholder="MM/DD/YYYY"
					autoComplete="off"
					id={name}
					name={name}
					value={field.value}
					required={!!field.required}
				/>
			</DatePicker>;
		case 'button':
			return <Button type="submit">{field.label}</Button>;
		case 'html':
			return <div>
				<FormLabel>{field.label}</FormLabel>
				<PostContent postContent={field.content} />
			</div>;
		case 'hidden':
			return <input type="hidden" name={name} value={field.value} id={name} />
		case 'text':
		case 'email':
		default:
			return <TextInput
				type={field.type}
				light
				id={name}
				labelText={field.label}
				name={name}
				defaultValue={field.value}
				required={!!field.required}
				disabled={!!field.disabled}
				placeholder={field.placeholder}
				autoComplete={name}
			/>;

	}
}

class FormFields extends React.Component {
	render() {
		return this.props.fields ? map(this.props.fields, (field, name) => (
			<div key={name} className={'tbk--form-fields__field-wrapper '+name+' '+(field && !!field.required ?'required':'')}>
				{field && field.instructions &&
				<div className="tbk--form-fields__description">{field.instructions}</div>
				}
				<FormField field={field} name={name} className={this.props.errors ? 'tbk--form-fields__invalid' : ''}/>
				{this.props.errors && this.props.errors[ name ] &&
					<div className="tbk--form-fields__error"><Icomoon icon="triangle-right" size="xs"/> {this.props.errors[ name ]}</div>
				}
			</div>
		)) : ''
	}

}

export {FormFields, FormField};



// WEBPACK FOOTER //
// ./src/components/FormFields/FormFields.js